import { useTranslation } from 'react-i18next';
import { MyLink } from '../MyLink';
import { CONTACT_PHONE } from '@/helpers/constants';
import IconWhatsApp from '../../assets/icons/icon_whatsapp.svg?react';
import s from './index.module.scss';

export const WhatsAppChatLink = () => {
  const phone = CONTACT_PHONE.replace('+', '').replaceAll(' ', '');
  const { t } = useTranslation('components');

  return (
    <MyLink href={`https://wa.me/${phone}`} className={s.link} isExternal newWindow>
      <IconWhatsApp />
      <span>{t('whatsapp_message.message_us_on_whatsapp')}</span>
    </MyLink>
  );
};
